/* Single source of truth: UI copy for en / fr / nl. Keys are shared across locales. */
export const translations = {
  en: {
    logoAlt: 'Mwuïlu',
    langName_en: 'English',
    langName_fr: 'Français',
    langName_nl: 'Nederlands',
    pickerLangEnglish: 'English',
    pickerLangFrench: 'Français',
    pickerLangDutch: 'Nederlands',
    selectYourLanguage: 'Select your language',
    ariaSelectLang: 'Select {label}',
    changeLanguage: 'Change language',
    ariaChangeLanguage: 'Change language',
    memberId: 'Member ID',
    accessCode: 'Access Code',
    enter: 'Enter',
    signingIn: 'Signing in',
    formMemberLogin: 'Member login',
    errEnterMemberId: 'Please enter your Member ID and Access Code.',
    errInvalidCredentials: 'Invalid Member ID or Access Code.',
    errServerUnreachable: 'Unable to reach the server. Please try again.',
    footerLine1:
      'Mwuïlu serves a private circle of embassies, consulates general, diplomatic staff, international institutions, and selected private clients.',
    footerLine2: 'Membership is by invitation only.',
    goodMorning: 'Good morning',
    goodAfternoon: 'Good afternoon',
    goodEvening: 'Good evening',
    howMayWeAttendLine1: 'How may we attend',
    howMayWeAttendLine2: 'to you today?',
    urgentOneCall: 'Urgent? One Call',
    ourServices: 'Our Services',
    tileFlightTitle: 'Flight Arrangements',
    tileFlightDesc: 'Business and first class only.',
    tileHotelsTitle: 'Partner Hotels',
    tileHotelsDesc: 'Preferred 4★ and 5★ hotels only.',
    tileTransfersTitle: 'Car Transfers',
    tileTransfersDesc: 'Private ground transportation.',
    tileAirportTitle: 'Airport Coordination',
    tileAirportDesc: 'Meet & greet, escort & transfer.',
    recentRequests: 'Recent Requests',
    viewAll: 'View all →',
    noRequestsYet: 'No requests yet. Submit a service request above.',
    home: 'Home',
    more: 'More',
    openMenu: 'Open menu',
    mainNavigation: 'Main navigation',
    bottomNavigation: 'Bottom navigation',
    servicesRegion: 'Services',
    recentRequestsRegion: 'Recent requests',
    expandSidebar: 'Expand sidebar',
    collapseSidebar: 'Collapse sidebar',
    navHome: 'Home',
    navRequestHistory: 'Request History',
    navFlightArrangements: 'Flight Arrangements',
    navPartnerHotels: 'Partner Hotels',
    navCarTransfers: 'Car Transfers',
    navAirportServices: 'Airport Services',
    navAbout: 'About',
    navBlog: 'Blog',
    navShortAviation: 'Arrangements',
    navShortHotels: 'Hotels',
    navShortTransfers: 'Transfers',
    ariaSwitchLang: 'Switch language',
    ariaSwitchTo: 'Switch to {code}',
    signOut: 'Sign Out',
    viewMyProfile: 'View my profile',
    myProfile: 'My Profile',
    servicePrivateAviation: 'Private Aviation',
    servicePartnerHotels: 'Partner Hotels',
    serviceCarTransfers: 'Car Transfers',
    serviceAirportServices: 'Airport Services',
    carTransferSingular: 'Car Transfer',
    status_submitted: 'Received',
    status_confirmed: 'Confirmed',
    status_in_progress: 'In Progress',
    status_completed: 'Completed',
    status_cancelled: 'Cancelled',
    trail_received: 'Received',
    trail_in_progress: 'In Progress',
    trail_confirmed: 'Confirmed',
    trail_completed: 'Completed',
    draftSavedFound: 'Saved draft found',
    draftSavedAria: 'Saved draft found',
    draftDetail:
      'You have an unsubmitted {serviceName} request saved from {savedDate}. Would you like to continue where you left off?',
    draftPreviously: 'previously',
    continueDraft: 'Continue draft',
    startNew: 'Start new',
    loading: 'Loading…',
    loadingAirports: 'Loading airports…',
    loadingProfile: 'Loading profile…',
    dashboard: 'Dashboard',
    serviceRequest: 'Service Request',
    reviewRequest: 'Review Request',
    pleaseReview: 'Please review your request',
    edit: 'Edit',
    confirmSubmit: 'Confirm & Submit',
    requestReceived: 'Request Received',
    requestReceivedBody: 'Your request has been received. We will be in touch within the hour.',
    signatureMwuilu: '— Mwuïlu',
    returnToDashboard: 'Return to Dashboard',
    failedSubmit: 'Failed to submit. Please try again.',
    back: 'Back',
    backToDashboard: 'Back to dashboard',
    tripType: 'Trip Type',
    oneWay: 'One Way',
    returnTrip: 'Return',
    route: 'Route',
    origin: 'Origin',
    destination: 'Destination',
    airportPlaceholder: 'City or IATA code (e.g. BRU)',
    airportNoResults: 'No airports found for "{query}"',
    dates: 'Dates',
    departureDate: 'Departure Date',
    returnDate: 'Return Date',
    flexibleDates: 'Flexible dates (±2 days)',
    cabinClass: 'Cabin Class',
    businessClass: 'Business Class',
    firstClass: 'First Class',
    passengers: 'Passengers',
    adults: 'Adults',
    children: 'Children',
    infants: 'Infants',
    childAge: 'Child {n} age',
    agePlaceholder: 'Age',
    checkedLuggage: 'Checked Luggage',
    numberOfBags: 'Number of bags',
    weightPerBag: 'Weight per bag (kg)',
    kgPlaceholder: 'kg',
    passengerDocuments: 'Passenger Documents',
    passportNoticeCompanion:
      'Select a saved companion to auto-fill their details, or upload a new document.',
    passengerN: 'Passenger {n}',
    passportDocument: 'Passport document',
    passportSecure:
      'Your documents are transmitted securely and handled with complete discretion.',
    additionalServices: 'Additional Services',
    includeMeetGreet: 'Include meet & greet and airport transfer for this journey',
    specialRequirements: 'Special Requirements',
    specialReqsPlaceholder: 'Dietary preferences, accessibility needs, specific requests…',
    decrease: 'Decrease {label}',
    increase: 'Increase {label}',
    removeFile: 'Remove file',
    camera: 'Camera',
    file: 'File',
    uploadDocument: 'Upload document',
    errFileTooLarge: 'File exceeds 10 MB.',
    myself: 'Myself',
    selectCompanion: 'Select companion…',
    otherPassenger: 'Other passenger',
    name: 'Name',
    passport: 'Passport',
    nationality: 'Nationality',
    companionDocNote: 'Your document on file. Upload a new one if details have changed.',
    confirmTripType: 'Trip type',
    confirmFrom: 'From',
    confirmTo: 'To',
    confirmDeparture: 'Departure',
    confirmReturn: 'Return',
    confirmFlexible: 'Flexible',
    confirmCabin: 'Cabin',
    confirmPassengers: 'Passengers',
    confirmBags: 'Checked bags',
    confirmAirportServices: 'Airport services',
    confirmPassportUploaded: '✓ Uploaded',
    confirmIncluded: 'Included',
    confirmYes: '±2 days',
    confirmNo: 'No',
    confirmFlexNo: 'No',
    adultSingular: 'adult',
    adultPlural: 'adults',
    childSingular: 'child',
    childPlural: 'children',
    infantSingular: 'infant',
    infantPlural: 'infants',
    passengerDetail: '{adults}{children}{infants}',
    urgentDeparture:
      'For departures within 24 hours, we are available to assist you directly. ',
    urgentDepartureLink: 'Contact us directly. Any hour, without exception.',
    privateAviation: 'Private Aviation',
    partnerHotelsTitle: 'Partner Hotels',
    headerNoteHotels: 'Partner properties only. No third-party aggregators.',
    country: 'Country',
    city: 'City',
    searchCountry: 'Search country…',
    searchCity: 'Search city…',
    selectCountryFirst: 'Select a country first',
    noCitiesForCountry: 'No cities on file for {country} — please specify in Special Requirements.',
    checkIn: 'Check-in',
    checkOut: 'Check-out',
    numberOfGuests: 'Number of Guests',
    guests: 'Guests',
    guestsSingular: 'guest',
    guestsPlural: 'guests',
    nightsSingular: '{n} night',
    nightsPlural: '{n} nights',
    roomPreferences: 'Room Preferences',
    roomSuite: 'Suite',
    roomConnecting: 'Connecting Rooms',
    roomHighFloor: 'High Floor',
    roomPrivacy: 'Complete Privacy',
    hotelSpecialPlaceholder: 'Accessibility needs, arrival time, specific requests…',
    duration: 'Duration',
    vehicleSedan: 'Executive Sedan',
    vehicleSedanDesc: 'Mercedes S-Class or equivalent',
    vehicleSuv: 'Luxury SUV',
    vehicleSuvDesc: 'Mercedes GLS or equivalent',
    vehicleVan: 'Executive Van',
    vehicleVanDesc: 'Mercedes V-Class or equivalent',
    vehicleMaybach: 'Maybach / Ultra Luxury',
    vehicleMaybachDesc: 'Subject to availability',
    vehicleSedanShort: 'Executive Sedan',
    vehicleSuvShort: 'Luxury SUV',
    vehicleVanShort: 'Executive Van',
    vehicleMaybachShort: 'Maybach / Ultra Luxury',
    journey: 'Journey',
    pickupLocation: 'Pickup Location',
    pickupPlaceholder: 'Hotel, address or landmark',
    dropoffPlaceholder: 'Hotel, airport or address',
    dateAndTime: 'Date & Time',
    date: 'Date',
    pickupTime: 'Pickup Time',
    vehiclePreference: 'Vehicle Preference',
    transferSpecialPlaceholder: 'Child seats, extra luggage, specific requirements…',
    passengerSingular: 'passenger',
    passengerPlural: 'passengers',
    carTransfersSuccessNote:
      'Once your booking is confirmed and payment received, you will receive an SMS confirmation with all transfer details.',
    airportTitle: 'Airport Services',
    flightDetails: 'Flight Details',
    airportField: 'Airport',
    airportNamePlaceholder: 'Airport name or IATA code',
    flightNumber: 'Flight Number',
    flightNumberPlaceholder: 'e.g. SN123',
    serviceRequired: 'Service Required',
    svcArrivalTitle: 'Arrival Meet & Greet',
    svcArrivalDesc: 'Our representative greets you at the aircraft or gate',
    svcDepartureTitle: 'Departure Escort',
    svcDepartureDesc: 'Full escort through check-in, security and to your gate',
    svcTransferTitle: 'Private Transfer',
    svcTransferDesc: 'Private vehicle to or from the airport',
    numberOfPassengers: 'Number of Passengers',
    airportSpecialPlaceholder: 'Accessibility needs, VIP requirements, specific requests…',
    confirmAirport: 'Airport',
    confirmFlightNumber: 'Flight number',
    confirmServices: 'Services',
    confirmVehicle: 'Vehicle',
    member: 'Member',
    journal: 'Journal',
    backToJournal: 'Back to journal',
    readMinutes: 'Read {time} →',
    readMinutesShort: '{time} →',
    articleReadMeta: '{date} · {readTime} read',
    aboutOverline: 'Mwuïlu',
    aboutTitle: 'About',
    aboutLead: 'Chief Facilitator of Private & Diplomatic Affairs.',
    aboutWhoLabel: 'Who We Are',
    aboutWhatLabel: 'What We Do',
    aboutHowLabel: 'How We Work',
    aboutMembershipLabel: 'Membership',
    officeHours: 'Office Hours',
    officeHoursDays: 'Monday — Friday',
    officeHoursTime: '9:00 — 18:00 CET',
    urgentMatters: 'Urgent Matters',
    urgentOutsideHours: 'Available outside office hours',
    connect: 'Connect',
    linkedIn: 'LinkedIn',
    ariaLinkedIn: 'Mwuïlu on LinkedIn',
    historyTitle: 'Request History',
    filterByService: 'Filter by service',
    filterAll: 'All',
    filterAviation: 'Aviation',
    filterHotels: 'Hotels',
    filterTransfers: 'Transfers',
    filterAirport: 'Airport',
    activeSection: 'Active',
    previousSection: 'Previous',
    allRequests: 'All Requests',
    requestDetail: 'Request Detail',
    reference: 'Reference',
    submitted: 'Submitted',
    status: 'Status',
    details: 'Details',
    historyNotice:
      'No pricing is displayed. Our team will be in touch with details of your arrangement.',
    backToHistory: 'Back to history',
    noRequestsYetAll: 'No submitted requests yet.',
    noRequestsForService: 'No {service} requests found.',
    notesPickup: 'Pickup {time}',
    notesFlexible: 'Flexible dates ±2 days',
    profileMemberOverline: 'Member',
    profileTitle: 'My Profile',
    changePhoto: 'Change photo',
    ariaChangePhoto: 'Change profile photo',
    memberIdLabel: 'Member ID',
    memberIdNote: 'Controlled by Mwuïlu. Not editable.',
    memberSince: 'Member since {date}',
    personalDetails: 'Personal Details',
    fullName: 'Full Name',
    placeholderPassportName: 'Exactly as on your passport',
    hintPassportName: 'Your name must match your passport exactly.',
    nameChangeAlert: 'A name change will be noted and sent to the Mwuïlu team for awareness.',
    emailAddress: 'Email Address',
    phoneNumber: 'Phone Number',
    phonePlaceholder: '+32 2 xxx xx xx',
    countryOfResidence: 'Country of Residence',
    selectCountry: 'Select country…',
    professionalDetails: 'Professional Details',
    institutionType: 'Client Classification',
    institutionOther: 'Institution Type (specify)',
    institutionName: 'Institution Name',
    institutionNamePlaceholder: 'Embassy of the UAE, Acme Group…',
    jobTitle: 'Job Title',
    jobTitlePlaceholder: 'Ambassador, CEO…',
    position: 'Position',
    positionPlaceholder: 'Head of Mission…',
    countryRepresented: 'Country Represented / Operates Under',
    savedCompanions: 'Saved Travel Companions',
    addCompanion: '+ Add companion',
    companionsHelp:
      'Companions saved here can be selected instantly when adding passengers to any request.',
    noCompanionsYet: 'No saved companions yet.',
    editCompanion: 'Edit companion',
    removeCompanion: 'Remove companion',
    relationship: 'Relationship',
    passportNumber: 'Passport Number',
    passportNumberPlaceholder: 'Passport number',
    selectEllipsis: 'Select…',
    roleSpouse: 'Spouse',
    rolePartner: 'Partner',
    roleFriend: 'Friend',
    roleFamilyMember: 'Family Member',
    roleParent: 'Parent',
    roleChild: 'Child',
    roleSibling: 'Sibling',
    roleAssistant: 'Assistant',
    roleColleague: 'Colleague',
    roleClient: 'Client',
    roleCaregiver: 'Caregiver',
    roleOther: 'Other',
    roleUnspecified: 'Unspecified',
    companionDefaultName: 'Companion {n}',
    failedLoadProfile: 'Failed to load profile.',
    avatarUploadFailed: 'Avatar upload failed.',
    profileUpdated: 'Profile updated successfully.',
    failedSave: 'Failed to save. Please try again.',
    saving: 'Saving…',
    saveChanges: 'Save Changes',
    instEmbassy: 'Private Client',
    instConsulateGeneral: 'Family Office',
    instConsulate: 'Private Office',
    instPermanentMission: 'Corporate Entity',
    instInternationalOrg: 'Government / Ministry',
    instPrivateOffice: 'Embassy / Consulate',
    instCorporate: 'Permanent Mission',
    instGovernmentMinistry: 'International Organization',
    instRoyalHousehold: 'Royal Household',
    instrepresent: 'Representative(on behalf of a principal)',
    instOther: 'Other',
    asOnPassport: 'As on passport',
    aboutWhoBody: `Mwuïlu is a private facilitation bureau operating at the intersection of diplomacy, discretion, and excellence. We serve a carefully selected circle of embassies, consulates general, permanent missions, international organisations, and private clients of the highest standing.

We do not advertise. We do not aggregate. We do not share. Every arrangement is handled personally, with full attention and complete confidentiality.`,
    aboutWhatBody: `Mwuïlu is a private facilitation company based in Belgium. We serve a carefully selected circle of embassies, consulates general, permanent missions, international organisations, and private clients whose affairs demand the highest standard of care.

Every arrangement is handled personally. Every detail is attended to with complete attention. Every confidence is kept without exception.

This is not a service we provide. It is simply how we work.`,
    aboutHowBody: `We arrange what matters most when time and discretion are non-negotiable. Flight arrangements, partner hotels, ground transfers, and airport coordination are handled from first contact to final confirmation by our team, not by an algorithm.

Our partners are selected for quality, reliability, and their understanding of the level of service our members expect. No third-party aggregators. No automated booking. Every detail, personally managed.

A request submitted through this portal reaches our team within minutes. We access the best available options across all cabin classes and present a curated proposal within the hour.

Payment is arranged through a secure link sent directly to you. No card data is stored on our servers. Passport and personal documents are encrypted, accessible only to our team, and deleted upon completion of your booking.

Our team is available Monday to Friday, 9 am to 6 pm CET. For urgent matters, including same-day and next-day requirements,  we remain reachable beyond these hours.`,
    aboutMembershipBody: `Membership with Mwuïlu is by invitation only. Each new member is personally vetted and brought on board through a direct introduction. There is no open registration.

If you are using this portal, you are already a valued member of our circle. We are honoured by the trust you place in us.`,
    blog1Category: 'Insight',
    blog1Title: 'The Art of the Quiet Arrival',
    blog1Excerpt:
      'What separates a seamless airport experience from a merely efficient one is not speed — it is the quality of anticipation. A note on how we approach every departure and arrival for our members.',
    blog1Date: '18 April 2026',
    blog1ReadTime: '4 min',
    blog1Body: `There is a particular kind of stress that accompanies air travel — not the fear of flying, but the accumulation of small uncertainties. Will the car be on time? Will the lounge be accessible? Will someone be waiting at the gate?

For the members we serve, these uncertainties are not merely inconvenient. They represent a gap between the standard expected and the standard received.

Our approach to airport coordination begins long before the aircraft lands. We confirm ground arrangements with the handling agent the evening prior. We track the flight in real time. Our representative is present not when the aircraft lands, but when it is approaching.

The quiet arrival is not an absence of service — it is its highest expression. The absence of friction, the absence of uncertainty, the presence of someone who already knows what is needed.

This is what we mean when we say we facilitate. Not simply to arrange, but to anticipate. To ensure that the space between one place and the next is, for our members, as seamless as everything that follows.`,
    blog2Category: 'Travel',
    blog2Title: 'Brussels in Spring: A Private View',
    blog2Excerpt:
      'For those who call Brussels home — or make it so for a season — the city reveals itself slowly. The institutional gravity of the EU quarter gives way, in April, to something far more intimate.',
    blog2Date: '11 April 2026',
    blog2ReadTime: '6 min',
    blog2Body: `Brussels resists easy characterisation. It is not Paris, though the architecture occasionally gestures in that direction. It is not Amsterdam, though the canals suggest a shared northern heritage. It is, most accurately, itself — quietly cosmopolitan, confidently understated, and almost pathologically reluctant to advertise.

In spring, the city opens. The Parc du Cinquantenaire becomes passable again without an overcoat. The terraces of the Châtelain neighbourhood fill at an hour that would, elsewhere, be considered premature. The Sablon antique market recovers its weekend purpose.

For members stationed in Brussels — at one of the city's many embassies or permanent missions — this seasonal shift is particularly pronounced. The city's diplomatic life accelerates in parallel with the warming weather, and the demand for seamless ground arrangements rises accordingly.

We have found, over the years, that Brussels rewards the member who looks beyond the obvious. The Stanhope and the Amigo remain the preferred addresses for a reason. But the smaller properties — the Pillows, the Made in Louise — offer a discretion and a quiet that the larger addresses cannot always guarantee.

If you are arriving in Brussels this spring, or if you have guests coming whom you would like to receive well, speak to us. We know the city, and we know what it asks of those who move through it.`,
    blog3Category: 'Aviation',
    blog3Title: 'On Cabin Class: Why We Offer Two, Not More',
    blog3Excerpt:
      'Mwuïlu arranges Business and First Class travel exclusively. This is not a limitation — it is a considered position. A brief explanation of why.',
    blog3Date: '03 April 2026',
    blog3ReadTime: '3 min',
    blog3Body: `We are occasionally asked whether we can arrange economy travel. The answer is no, and the reason is straightforward.

The members we serve travel for reasons that do not accommodate compromise. A session in The Hague. A bilateral at an undisclosed location. A family matter that requires immediate presence and complete discretion. The quality of travel is not a luxury consideration in these circumstances — it is a functional one.

Business Class, on the routes and carriers we work with, provides the separation, the quiet, and the flexibility that this kind of travel demands. First Class extends this further, with the addition of privacy suites on long-haul routes that have become, for some of our members, the only acceptable option for certain journeys.

We do not offer economy travel because we cannot offer it well. And we are not in the business of doing things poorly.

When you submit a flight request through this portal, you will find two options: Business and First. If you have a preference for a specific carrier, or a specific configuration on a specific aircraft, tell us. We will do our best to accommodate it. That is what we are here for.`,
  },
  fr: {
    logoAlt: 'Mwuïlu',
    langName_en: 'Anglais',
    langName_fr: 'Français',
    langName_nl: 'Néerlandais',
    pickerLangEnglish: 'English',
    pickerLangFrench: 'Français',
    pickerLangDutch: 'Nederlands',
    selectYourLanguage: 'Choisissez votre langue',
    ariaSelectLang: 'Sélectionner {label}',
    changeLanguage: 'Changer de langue',
    ariaChangeLanguage: 'Changer de langue',
    memberId: 'Identifiant membre',
    accessCode: "Code d'accès",
    enter: 'Entrer',
    signingIn: 'Connexion…',
    formMemberLogin: 'Connexion membre',
    errEnterMemberId: 'Veuillez saisir votre identifiant membre et votre code daccès.',
    errInvalidCredentials: 'Identifiant membre ou code daccès invalide.',
    errServerUnreachable: 'Impossible de joindre le serveur. Veuillez réessayer.',
    footerLine1:
      'Mwuïlu sert un cercle privé dambassades, de consulats généraux, de personnel diplomatique, dinstitutions internationales et de clients privés sélectionnés.',
    footerLine2: 'Ladhésion est sur invitation uniquement.',
    goodMorning: 'Bonjour',
    goodAfternoon: 'Bon après-midi',
    goodEvening: 'Bonsoir',
    howMayWeAttendLine1: 'En quoi pouvons-nous',
    howMayWeAttendLine2: 'vous assister aujourd hui ?',
    urgentOneCall: 'Urgent ? Un appel suffit',
    ourServices: 'Nos services',
    tileFlightTitle: 'Réservations de vol',
    tileFlightDesc: 'Affaires et première classe uniquement.',
    tileHotelsTitle: 'Hôtels partenaires',
    tileHotelsDesc: 'Hôtels 4★ et 5★ préférentiels uniquement.',
    tileTransfersTitle: 'Transferts en voiture',
    tileTransfersDesc: 'Transport terrestre privé.',
    tileAirportTitle: 'Coordination aéroportuaire',
    tileAirportDesc: 'Accueil, accompagnement et transfert.',
    recentRequests: 'Demandes récentes',
    viewAll: 'Tout voir →',
    noRequestsYet: 'Aucune demande pour le moment. Soumettez une demande ci-dessus.',
    home: 'Accueil',
    more: 'Plus',
    openMenu: 'Ouvrir le menu',
    mainNavigation: 'Navigation principale',
    bottomNavigation: 'Navigation inférieure',
    servicesRegion: 'Services',
    recentRequestsRegion: 'Demandes récentes',
    expandSidebar: 'Développer le menu',
    collapseSidebar: 'Réduire le menu',
    navHome: 'Accueil',
    navRequestHistory: 'Historique des demandes',
    navFlightArrangements: 'Réservations de vol',
    navPartnerHotels: 'Hôtels partenaires',
    navCarTransfers: 'Transferts en voiture',
    navAirportServices: 'Services aéroportuaires',
    navAbout: 'À propos',
    navBlog: 'Blog',
    navShortAviation: 'Vols',
    navShortHotels: 'Hôtels',
    navShortTransfers: 'Transferts',
    ariaSwitchLang: 'Changer de langue',
    ariaSwitchTo: 'Passer à {code}',
    signOut: 'Se déconnecter',
    viewMyProfile: 'Voir mon profil',
    myProfile: 'Mon profil',
    servicePrivateAviation: 'Aviation privée',
    servicePartnerHotels: 'Hôtels partenaires',
    serviceCarTransfers: 'Transferts en voiture',
    serviceAirportServices: 'Services aéroportuaires',
    carTransferSingular: 'Transfert en voiture',
    status_submitted: 'Reçu',
    status_confirmed: 'Confirmé',
    status_in_progress: 'En cours',
    status_completed: 'Terminé',
    status_cancelled: 'Annulé',
    trail_received: 'Reçu',
    trail_in_progress: 'En cours',
    trail_confirmed: 'Confirmé',
    trail_completed: 'Terminé',
    draftSavedFound: 'Brouillon enregistré trouvé',
    draftSavedAria: 'Brouillon enregistré trouvé',
    draftDetail:
      'Vous avez une demande {serviceName} non soumise enregistrée depuis le {savedDate}. Souhaitez-vous reprendre où vous vous étiez arrêté ?',
    draftPreviously: 'précédemment',
    continueDraft: 'Reprendre le brouillon',
    startNew: 'Nouveau formulaire',
    loading: 'Chargement…',
    loadingAirports: 'Chargement des aéroports…',
    loadingProfile: 'Chargement du profil…',
    dashboard: 'Tableau de bord',
    serviceRequest: 'Demande de service',
    reviewRequest: 'Vérifier la demande',
    pleaseReview: 'Veuillez vérifier votre demande',
    edit: 'Modifier',
    confirmSubmit: 'Confirmer et envoyer',
    requestReceived: 'Demande reçue',
    requestReceivedBody: 'Votre demande a bien été reçue. Nous vous recontactons dans l heure.',
    signatureMwuilu: '— Mwuïlu',
    returnToDashboard: 'Retour au tableau de bord',
    failedSubmit: "Échec de l'envoi. Veuillez réessayer.",
    back: 'Retour',
    backToDashboard: 'Retour au tableau de bord',
    tripType: 'Type de voyage',
    oneWay: 'Aller simple',
    returnTrip: 'Aller-retour',
    route: 'Itinéraire',
    origin: "Départ",
    destination: 'Arrivée',
    airportPlaceholder: 'Ville ou code IATA (ex. BRU)',
    airportNoResults: 'Aucun aéroport trouvé pour « {query} »',
    dates: 'Dates',
    departureDate: 'Date de départ',
    returnDate: 'Date de retour',
    flexibleDates: 'Dates flexibles (±2 jours)',
    cabinClass: 'Classe de cabine',
    businessClass: 'Classe affaires',
    firstClass: 'Première classe',
    passengers: 'Passagers',
    adults: 'Adultes',
    children: 'Enfants',
    infants: 'Bébés',
    childAge: 'Âge de l enfant {n}',
    agePlaceholder: 'Âge',
    checkedLuggage: 'Bagages en soute',
    numberOfBags: 'Nombre de bagages',
    weightPerBag: 'Poids par bagage (kg)',
    kgPlaceholder: 'kg',
    passengerDocuments: 'Documents des passagers',
    passportNoticeCompanion:
      'Choisissez un compagnon enregistré pour préremplir les informations, ou téléchargez un nouveau document.',
    passengerN: 'Passager {n}',
    passportDocument: 'Document de passeport',
    passportSecure:
      'Vos documents sont transmis en toute sécurité et traités avec une discrétion absolue.',
    additionalServices: 'Services additionnels',
    includeMeetGreet: 'Inclure accueil & transfert aéroportuaire pour ce voyage',
    specialRequirements: 'Demandes particulières',
    specialReqsPlaceholder: 'Régimes alimentaires, accessibilité, demandes spécifiques…',
    decrease: 'Diminuer {label}',
    increase: 'Augmenter {label}',
    removeFile: 'Supprimer le fichier',
    camera: 'Appareil photo',
    file: 'Fichier',
    uploadDocument: 'Télécharger un document',
    errFileTooLarge: 'Le fichier dépasse 10 Mo.',
    myself: 'Moi-même',
    selectCompanion: 'Choisir un compagnon…',
    otherPassenger: 'Autre passager',
    name: 'Nom',
    passport: 'Passeport',
    nationality: 'Nationalité',
    companionDocNote: 'Document en dossier. Téléchargez-en un nouveau si les informations ont changé.',
    confirmTripType: 'Type de voyage',
    confirmFrom: 'De',
    confirmTo: 'Vers',
    confirmDeparture: 'Départ',
    confirmReturn: 'Retour',
    confirmFlexible: 'Flexibilité',
    confirmCabin: 'Cabine',
    confirmPassengers: 'Passagers',
    confirmBags: 'Bagages en soute',
    confirmAirportServices: 'Services aéroportuaires',
    confirmPassportUploaded: '✓ Téléchargé',
    confirmIncluded: 'Inclus',
    confirmYes: '±2 jours',
    confirmNo: 'Non',
    confirmFlexNo: 'Non',
    adultSingular: 'adulte',
    adultPlural: 'adultes',
    childSingular: 'enfant',
    childPlural: 'enfants',
    infantSingular: 'bébé',
    infantPlural: 'bébés',
    passengerDetail: '{adults}{children}{infants}',
    urgentDeparture:
      'Pour les départs dans les 24 heures, nous sommes disponibles pour vous assister directement. ',
    urgentDepartureLink: 'Contactez-nous directement. À toute heure, sans exception.',
    privateAviation: 'Aviation privée',
    partnerHotelsTitle: 'Hôtels partenaires',
    headerNoteHotels: 'Établissements partenaires uniquement. Pas d agrégateurs tiers.',
    country: 'Pays',
    city: 'Ville',
    searchCountry: 'Rechercher un pays…',
    searchCity: 'Rechercher une ville…',
    selectCountryFirst: 'Sélectionnez d abord un pays',
    noCitiesForCountry: 'Aucune ville répertoriée pour {country} — précisez-le dans les demandes particulières.',
    checkIn: 'Arrivée',
    checkOut: 'Départ',
    numberOfGuests: 'Nombre d invités',
    guests: 'Invités',
    guestsSingular: 'invité',
    guestsPlural: 'invités',
    nightsSingular: '{n} nuit',
    nightsPlural: '{n} nuits',
    roomPreferences: 'Préférences de chambre',
    roomSuite: 'Suite',
    roomConnecting: 'Chambres communicantes',
    roomHighFloor: 'Étage élevé',
    roomPrivacy: 'Confidentialité totale',
    hotelSpecialPlaceholder: 'Accessibilité, heure d arrivée, demandes spécifiques…',
    duration: 'Durée',
    vehicleSedan: 'Berline de prestige',
    vehicleSedanDesc: 'Mercedes Classe S ou équivalent',
    vehicleSuv: 'SUV de luxe',
    vehicleSuvDesc: 'Mercedes GLS ou équivalent',
    vehicleVan: 'Van de prestige',
    vehicleVanDesc: 'Mercedes Classe V ou équivalent',
    vehicleMaybach: 'Maybach / ultra-luxe',
    vehicleMaybachDesc: 'Sous réserve de disponibilité',
    vehicleSedanShort: 'Berline de prestige',
    vehicleSuvShort: 'SUV de luxe',
    vehicleVanShort: 'Van de prestige',
    vehicleMaybachShort: 'Maybach / ultra-luxe',
    journey: 'Trajet',
    pickupLocation: 'Lieu de prise en charge',
    pickupPlaceholder: 'Hôtel, adresse ou point de repère',
    dropoffPlaceholder: 'Hôtel, aéroport ou adresse',
    dateAndTime: 'Date et heure',
    date: 'Date',
    pickupTime: 'Heure de prise en charge',
    vehiclePreference: 'Préférence de véhicule',
    transferSpecialPlaceholder: 'Sièges enfants, bagages supplémentaires, demandes spécifiques…',
    passengerSingular: 'passager',
    passengerPlural: 'passagers',
    carTransfersSuccessNote:
      'Une fois la réservation confirmée et le paiement reçu, vous recevrez un SMS avec tous les détails du transfert.',
    airportTitle: 'Services aéroportuaires',
    flightDetails: 'Détails du vol',
    airportField: 'Aéroport',
    airportNamePlaceholder: 'Nom de l aéroport ou code IATA',
    flightNumber: 'Numéro de vol',
    flightNumberPlaceholder: 'ex. SN123',
    serviceRequired: 'Service requis',
    svcArrivalTitle: 'Accueil à l arrivée',
    svcArrivalDesc: 'Notre représentant vous accueille à l avion ou à la porte',
    svcDepartureTitle: 'Accompagnement au départ',
    svcDepartureDesc: 'Accompagnement complet jusqu à la porte d embarquement',
    svcTransferTitle: 'Transfert privé',
    svcTransferDesc: 'Véhicule privé vers ou depuis l aéroport',
    numberOfPassengers: 'Nombre de passagers',
    airportSpecialPlaceholder: 'Accessibilité, exigences VIP, demandes spécifiques…',
    confirmAirport: 'Aéroport',
    confirmFlightNumber: 'Numéro de vol',
    confirmServices: 'Services',
    confirmVehicle: 'Véhicule',
    member: 'Membre',
    journal: 'Journal',
    backToJournal: 'Retour au journal',
    readMinutes: 'Lire {time} →',
    readMinutesShort: '{time} →',
    articleReadMeta: '{date} · lecture {readTime}',
    aboutOverline: 'Mwuïlu',
    aboutTitle: 'À propos',
    aboutLead: 'Facilitateur en chef des affaires privées et diplomatiques.',
    aboutWhoLabel: 'Qui nous sommes',
    aboutWhatLabel: 'Ce que nous faisons',
    aboutHowLabel: 'Comment nous travaillons',
    aboutMembershipLabel: 'Adhésion',
    officeHours: 'Heures de bureau',
    officeHoursDays: 'Lundi — vendredi',
    officeHoursTime: '9:00 — 18:00 CET',
    urgentMatters: 'Urgences',
    urgentOutsideHours: 'Disponibilité en dehors des heures de bureau',
    connect: 'Contact',
    linkedIn: 'LinkedIn',
    ariaLinkedIn: 'Mwuïlu sur LinkedIn',
    historyTitle: 'Historique des demandes',
    filterByService: 'Filtrer par service',
    filterAll: 'Tous',
    filterAviation: 'Aviation',
    filterHotels: 'Hôtels',
    filterTransfers: 'Transferts',
    filterAirport: 'Aéroport',
    activeSection: 'Actives',
    previousSection: 'Précédentes',
    allRequests: 'Toutes les demandes',
    requestDetail: 'Détail de la demande',
    reference: 'Référence',
    submitted: 'Soumis',
    status: 'Statut',
    details: 'Détails',
    historyNotice:
      'Aucun tarif n est affiché. Notre équipe vous contactera avec les détails de votre arrangement.',
    backToHistory: 'Retour à l historique',
    noRequestsYetAll: 'Aucune demande soumise pour le moment.',
    noRequestsForService: 'Aucune demande {service} trouvée.',
    notesPickup: 'Prise en charge {time}',
    notesFlexible: 'Dates flexibles ±2 jours',
    profileMemberOverline: 'Membre',
    profileTitle: 'Mon profil',
    changePhoto: 'Changer la photo',
    ariaChangePhoto: 'Changer la photo de profil',
    memberIdLabel: 'Identifiant membre',
    memberIdNote: 'Contrôlé par Mwuïlu. Non modifiable.',
    memberSince: 'Membre depuis {date}',
    personalDetails: 'Informations personnelles',
    fullName: 'Nom complet',
    placeholderPassportName: 'Exactement comme sur votre passeport',
    hintPassportName: 'Votre nom doit correspondre exactement à votre passeport.',
    nameChangeAlert: 'Un changement de nom sera notifié à l équipe Mwuïlu.',
    emailAddress: 'Adresse e-mail',
    phoneNumber: 'Numéro de téléphone',
    phonePlaceholder: '+32 2 xxx xx xx',
    countryOfResidence: 'Pays de résidence',
    selectCountry: 'Sélectionner un pays…',
    professionalDetails: 'Informations professionnelles',
    institutionType: "Classement des clients",
    institutionOther: "Type d'institution (préciser)",
    institutionName: "Nom de l'institution",
    institutionNamePlaceholder: 'Ambassade des EAU, Acme Group…',
    jobTitle: 'Fonction',
    jobTitlePlaceholder: 'Ambassadeur, PDG…',
    position: 'Poste',
    positionPlaceholder: 'Chef de mission…',
    countryRepresented: 'Pays représenté / Opère sous',
    savedCompanions: 'Compagnons de voyage enregistrés',
    addCompanion: '+ Ajouter un compagnon',
    companionsHelp:
      'Les compagnons enregistrés ici peuvent être sélectionnés instantanément lors de vos demandes.',
    noCompanionsYet: 'Aucun compagnon enregistré pour le moment.',
    editCompanion: 'Modifier le compagnon',
    removeCompanion: 'Retirer le compagnon',
    relationship: 'Lien',
    passportNumber: 'Numéro de passeport',
    passportNumberPlaceholder: 'Numéro de passeport',
    selectEllipsis: 'Sélectionner…',
    roleSpouse: 'Conjoint·e',
    rolePartner: 'Partenaire',
    roleFriend: 'Ami·e',
    roleFamilyMember: 'Membre de la famille',
    roleParent: 'Parent',
    roleChild: 'Enfant',
    roleSibling: 'Frère / Sœur',
    roleAssistant: 'Assistant·e',
    roleColleague: 'Collègue',
    roleClient: 'Client·e',
    roleCaregiver: 'Accompagnant·e',
    roleOther: 'Autre',
    roleUnspecified: 'Non précisé',
    companionDefaultName: 'Compagnon {n}',
    failedLoadProfile: 'Échec du chargement du profil.',
    avatarUploadFailed: 'Échec du téléchargement de la photo.',
    profileUpdated: 'Profil mis à jour.',
    failedSave: 'Échec de l enregistrement. Veuillez réessayer.',
    saving: 'Enregistrement…',
    saveChanges: 'Enregistrer',
    instEmbassy: 'Clientèle privée',
    instConsulateGeneral: 'Bureau familial',
    instConsulate: 'Bureau privé',
    instPermanentMission: 'Entité corporative',
    instInternationalOrg: 'Gouvernement / Ministère',
    instPrivateOffice: 'Ambassade / Consulat',
    instCorporate: 'Mission permanente',
    instGovernmentMinistry: 'Organisation internationale',
    instRoyalHousehold: 'Maison royale',
    instrepresent: 'Représentant (pour le compte d un mandant)',
    instOther: 'Autre',
    asOnPassport: 'Comme sur le passeport',
    aboutWhoBody: `Mwuïlu est un bureau de facilitation privée à la croisée de la diplomatie, de la discrétion et de l'excellence. Nous accompagnons un cercle restreint d'ambassades, de consulats généraux, de missions permanentes, d'organisations internationales et de clients privés du plus haut niveau.

Nous ne faisons pas de publicité. Nous n'agrégeons pas. Nous ne partageons pas. Chaque demande est traitée personnellement, avec une attention totale et une confidentialité absolue.`,
    aboutWhatBody: `Mwuïlu est une société de facilitation privée basée en Belgique. Nous servons un cercle sélectionné d'ambassades, de consulats généraux, de missions permanentes, d'organisations internationales et de clients privés dont les dossiers exigent le plus haut niveau d'exigence.

Chaque arrangement est géré personnellement. Chaque détail est traité avec une attention complète. Chaque confidence est préservée sans exception.

Ce n est pas un « service » que nous vendons. C'est ainsi que nous travaillons.`,
    aboutHowBody: `Nous organisons ce qui compte lorsque le temps et la discrétion ne sont pas négociables. Vols, hôtels partenaires, transferts et coordination aéroportuaire sont suivis du premier contact jusqu à la confirmation finale par notre équipe, pas par un algorithme.

Nos partenaires sont choisis pour leur qualité, leur fiabilité et leur compréhension du niveau de service attendu par nos membres. Pas d agrégateurs tiers. Pas de réservation automatisée. Chaque détail est géré personnellement.

Une demande envoyée via ce portail parvient à notre équipe en quelques minutes. Nous explorons les meilleures options dans toutes les classes de cabine et présentons une proposition sur mesure dans l'heure.

Le paiement se fait via un lien sécurisé qui vous est envoyé directement. Aucune carte n est stockée sur nos serveurs. Les passeports et documents personnels sont chiffrés, accessibles uniquement à notre équipe et supprimés une fois la réservation terminée.

Notre équipe est joignable du lundi au vendredi, 9h à 18h CET. Pour les situations urgentes, y compris le jour même ou le lendemain, nous restons joignables en dehors de ces plages.`,
    aboutMembershipBody: `L'adhésion à Mwuïlu est strictement sur invitation. Chaque nouveau membre est validé personnellement et intégré sur recommandation directe. Aucune inscription publique.

Si vous utilisez ce portail, vous êtes déjà un membre apprécié de notre cercle. Nous sommes honorés de la confiance que vous nous accordez.`,
    blog1Category: 'Analyse',
    blog1Title: 'L art de larrivée discrète',
    blog1Excerpt:
      'Ce qui distingue une expérience aéroportuaire fluide d une expérience simplement efficace, ce n est pas la vitesse — c est la qualité de l anticipation. Une note sur notre manière d aborder chaque départ et chaque arrivée pour nos membres.',
    blog1Date: '18 avril 2026',
    blog1ReadTime: '4 min',
    blog1Body: `Il existe une forme de tension propre au voyage aérien — non la peur de l avion, mais l'accumulation de petites incertitudes. La voiture sera-t-elle à l'heure ? Le salon sera-t-il accessible ? Quelqu'un attendra-t-il à la porte ?

Pour les membres que nous servons, ces incertitudes ne sont pas de simples désagréments. Elles traduisent l'écart entre le niveau attendu et le niveau reçu.

Notre approche de la coordination aéroportuaire commence bien avant l'atterrissage. Nous confirmons les dispositions au sol avec l'agent de piste la veille au soir. Nous suivons le vol en temps réel. Notre représentant n est pas « à l'arrivée de l avion » : il est en place quand l avion s'approche.

L'arrivée discrète n est pas l'absence de service — c'est sa forme la plus aboutie. L'absence de friction, l'absence d'incertitude, la présence de quelqu'un qui sait déjà ce dont il s'agit.

C'est ce que nous entendons par faciliter. Non seulement organiser, mais anticiper. Pour que l'espace d un lieu à l'autre soit, pour nos membres, aussi fluide que tout ce qui suit.`,
    blog2Category: 'Voyage',
    blog2Title: 'Bruxelles au printemps : un regard privé',
    blog2Excerpt:
      'Pour ceux qui font de Bruxelles leur foyer — ou leur cadre pour une saison — la ville se dévoile lentement. La pesanteur institutionnelle du quartier européen, en avril, cède devant quelque chose de plus intime.',
    blog2Date: '11 avril 2026',
    blog2ReadTime: '6 min',
    blog2Body: `Bruxelles résiste aux étiquettes faciles. Ce n est pas Paris, même si l'architecture y fait parfois signe. Ce n est pas Amsterdam, même si les canaux évoquent une parenté nordique. C'est, le plus justement, elle-même — cosmopolite avec retenue, d une élégance tranquille, et presque réticente à se mettre en avant.

Au printemps, la ville s'ouvre. Le Parc du Cinquantenaire redevient praticable sans pardessus. Les terrasses du Châtelain se remplissent à une heure qui, ailleurs, semblerait hâtive. Le marché aux antiquités du Sablon retrouve son rôle du week-end.

Pour les membres en poste à Bruxelles — dans l'une des nombreuses ambassades ou missions — ce basculement saisonnier est particulièrement sensible. La vie diplomatique s'accélère avec le redoux, et la demande de dispositifs au sol irréprochables augmente en parallèle.

Au fil des années, nous avons vu que Bruxelles récompense celui qui regarde au-delà des adresses évidentes. Le Stanhope et l'Amigo restent des références pour de bonnes raisons. Mais les adresses plus petites — le Pillows, le Made in Louise — offrent parfois une discrétion et un calme que les grands palais ne garantissent pas toujours.

Si vous arrivez à Bruxelles ce printemps, ou si vous recevez des invités que vous souhaitez accueillir comme il se doit, parlez-nous. Nous connaissons la ville — et ce qu'elle exige de ceux qui la traversent.`,
    blog3Category: 'Aviation',
    blog3Title: 'Classes de cabine : pourquoi seulement deux',
    blog3Excerpt:
      'Mwuïlu organise exclusivement des voyages en classe Affaires et Première. Ce n est pas une contrainte — c est un choix assumé. Une brève explication.',
    blog3Date: '3 avril 2026',
    blog3ReadTime: '3 min',
    blog3Body: `On nous demande parfois si nous pouvons organiser des trajets en classe Économique. La réponse est non, et la raison est simple.

Les membres que nous accompagnons voyagent dans des contextes qui ne tolèrent pas le compromis. Une audience à La Haye. Un bilatéral dans un lieu non divulgué. Une affaire familiale qui impose présence immédiate et discrétion totale. La qualité du voyage n'y est pas un « confort » — elle est fonctionnelle.

La classe Affaires, sur les lignes et compagnies avec lesquelles nous travaillons, offre la séparation, le calme et la flexibilité que ce type de déplacements exige. La Première va plus loin, avec des suites de confidentialité sur le long-courrier qui sont, pour certains de nos membres, la seule option acceptable sur certains trajets.

Nous ne proposons pas l'Économique parce que nous ne pouvons pas l'exécuter à la hauteur de notre exigence. Et nous ne faisons pas les choses à moitié.

Lorsque vous soumettez une demande de vol via ce portail, vous trouverez deux options : Affaires et Première. Si vous avez une préférence pour une compagnie, une configuration ou un appareil précis, indiquez-le. Nous ferons le maximum pour l'honorer. C'est pour cela que nous sommes là.`,
  },
  nl: {
    logoAlt: 'Mwuïlu',
    langName_en: 'English',
    langName_fr: 'Français',
    langName_nl: 'Nederlands',
    pickerLangEnglish: 'English',
    pickerLangFrench: 'Français',
    pickerLangDutch: 'Nederlands',
    selectYourLanguage: 'Kies uw taal',
    ariaSelectLang: '{label} selecteren',
    changeLanguage: 'Taal wijzigen',
    ariaChangeLanguage: 'Taal wijzigen',
    memberId: 'Lidnummer',
    accessCode: 'Toegangscode',
    enter: 'Ga verder',
    signingIn: 'Bezig met aanmelden…',
    formMemberLogin: 'Lidaanmelding',
    errEnterMemberId: 'Voer uw lidnummer en toegangscode in.',
    errInvalidCredentials: 'Ongeldig lidnummer of toegangscode.',
    errServerUnreachable: 'Server niet bereikbaar. Probeer het later opnieuw.',
    footerLine1:
      'Mwuïlu bedient een besloten kring van ambassades, consulaten‑generaal, diplomatieke medewerkers, internationale instellingen en uitgekozen particuliere cliënten.',
    footerLine2: 'Lidmaatschap alleen op uitnodiging.',
    goodMorning: 'Goedemorgen',
    goodAfternoon: 'Goedemiddag',
    goodEvening: 'Goedenavond',
    howMayWeAttendLine1: 'Waarmee kunnen wij',
    howMayWeAttendLine2: 'u vandaag van dienst zijn?',
    urgentOneCall: 'Urgent? Eén telefoontje',
    ourServices: 'Onze diensten',
    tileFlightTitle: 'Vluchtregeling',
    tileFlightDesc: 'Alleen business- en firstclass.',
    tileHotelsTitle: 'Partnerhotels',
    tileHotelsDesc: 'Alleen geselecteerde 4★- en 5★-hotels.',
    tileTransfersTitle: 'Autotransfers',
    tileTransfersDesc: 'Privévervoer over de grond.',
    tileAirportTitle: 'Luchthavencoördinatie',
    tileAirportDesc: 'Meet & greet, begeleiding en transfer.',
    recentRequests: 'Recente verzoeken',
    viewAll: 'Alles tonen →',
    noRequestsYet: 'Nog geen verzoeken. Dien hierboven een dienstverzoek in.',
    home: 'Start',
    more: 'Meer',
    openMenu: 'Menu openen',
    mainNavigation: 'Hoofdnavigatie',
    bottomNavigation: 'Onderste navigatie',
    servicesRegion: 'Diensten',
    recentRequestsRegion: 'Recente verzoeken',
    expandSidebar: 'Zijbalk uitvouwen',
    collapseSidebar: 'Zijbalk invouwen',
    navHome: 'Start',
    navRequestHistory: 'Verzoekgeschiedenis',
    navFlightArrangements: 'Vluchtregeling',
    navPartnerHotels: 'Partnerhotels',
    navCarTransfers: 'Autotransfers',
    navAirportServices: 'Luchthavendiensten',
    navAbout: 'Over ons',
    navBlog: 'Blog',
    navShortAviation: 'Vluchten',
    navShortHotels: 'Hotels',
    navShortTransfers: 'Transfers',
    ariaSwitchLang: 'Taal wijzigen',
    ariaSwitchTo: 'Schakel naar {code}',
    signOut: 'Afmelden',
    viewMyProfile: 'Mijn profiel bekijken',
    myProfile: 'Mijn profiel',
    servicePrivateAviation: 'Privéluchtvaart',
    servicePartnerHotels: 'Partnerhotels',
    serviceCarTransfers: 'Autotransfers',
    serviceAirportServices: 'Luchthavendiensten',
    carTransferSingular: 'Autotransfer',
    status_submitted: 'Ontvangen',
    status_confirmed: 'Bevestigd',
    status_in_progress: 'In behandeling',
    status_completed: 'Afgerond',
    status_cancelled: 'Geannuleerd',
    trail_received: 'Ontvangen',
    trail_in_progress: 'In behandeling',
    trail_confirmed: 'Bevestigd',
    trail_completed: 'Afgerond',
    draftSavedFound: 'Opgeslagen concept gevonden',
    draftSavedAria: 'Opgeslagen concept gevonden',
    draftDetail:
      'U heeft een niet-ingediend {serviceName}-verzoek opgeslagen van {savedDate}. Wilt u verdergaan waar u gebleven was?',
    draftPreviously: 'eerder',
    continueDraft: 'Concept voortzetten',
    startNew: 'Opnieuw beginnen',
    loading: 'Laden…',
    loadingAirports: 'Luchthavens laden…',
    loadingProfile: 'Profiel laden…',
    dashboard: 'Dashboard',
    serviceRequest: 'Dienstverzoek',
    reviewRequest: 'Verzoek controleren',
    pleaseReview: 'Controleer uw verzoek',
    edit: 'Bewerken',
    confirmSubmit: 'Bevestigen en verzenden',
    requestReceived: 'Verzoek ontvangen',
    requestReceivedBody: 'Uw verzoek is ontvangen. We nemen binnen het uur contact met u op.',
    signatureMwuilu: '— Mwuïlu',
    returnToDashboard: 'Terug naar dashboard',
    failedSubmit: 'Verzenden mislukt. Probeer het opnieuw.',
    back: 'Terug',
    backToDashboard: 'Terug naar dashboard',
    tripType: 'Reistype',
    oneWay: 'Enkele reis',
    returnTrip: 'Retour',
    route: 'Route',
    origin: 'Vertrek',
    destination: 'Bestemming',
    airportPlaceholder: 'Stad of IATA-code (bijv. BRU)',
    airportNoResults: 'Geen luchthavens gevonden voor « {query} »',
    dates: 'Data',
    departureDate: 'Vertrekdatum',
    returnDate: 'Retourdatum',
    flexibleDates: 'Flexibele data (±2 dagen)',
    cabinClass: 'Cabineklasse',
    businessClass: 'Businessclass',
    firstClass: 'First class',
    passengers: 'Passagiers',
    adults: 'Volwassenen',
    children: 'Kinderen',
    infants: 'Baby s',
    childAge: 'Leeftijd kind {n}',
    agePlaceholder: 'Leeftijd',
    checkedLuggage: 'Ingecheckte bagage',
    numberOfBags: 'Aantal koffers',
    weightPerBag: 'Gewicht per koffer (kg)',
    kgPlaceholder: 'kg',
    passengerDocuments: 'Passagiersdocumenten',
    passportNoticeCompanion:
      'Kies een opgeslagen metgezel om gegevens in te vullen, of upload een nieuw document.',
    passengerN: 'Passagier {n}',
    passportDocument: 'Paspoortdocument',
    passportSecure:
      'Uw documenten worden veilig verzonden en met volledige discretie behandeld.',
    additionalServices: 'Extra diensten',
    includeMeetGreet: 'Inclusief meet & greet en luchthaventransfer voor deze reis',
    specialRequirements: 'Bijzondere wensen',
    specialReqsPlaceholder: 'Dieetwensen, toegankelijkheid, specifieke verzoeken…',
    decrease: 'Verlaag {label}',
    increase: 'Verhoog {label}',
    removeFile: 'Bestand verwijderen',
    camera: 'Camera',
    file: 'Bestand',
    uploadDocument: 'Document uploaden',
    errFileTooLarge: 'Bestand is groter dan 10 MB.',
    myself: 'Ik zelf',
    selectCompanion: 'Metgezel kiezen…',
    otherPassenger: 'Andere passagier',
    name: 'Naam',
    passport: 'Paspoort',
    nationality: 'Nationaliteit',
    companionDocNote: 'Uw document in het dossier. Upload een nieuw document als gegevens zijn gewijzigd.',
    confirmTripType: 'Reistype',
    confirmFrom: 'Van',
    confirmTo: 'Naar',
    confirmDeparture: 'Vertrek',
    confirmReturn: 'Retour',
    confirmFlexible: 'Flexibel',
    confirmCabin: 'Cabine',
    confirmPassengers: 'Passagiers',
    confirmBags: 'Ingecheckte bagage',
    confirmAirportServices: 'Luchthavendiensten',
    confirmPassportUploaded: '✓ Geüpload',
    confirmIncluded: 'Inbegrepen',
    confirmYes: '±2 dagen',
    confirmNo: 'Nee',
    confirmFlexNo: 'Nee',
    adultSingular: 'volwassene',
    adultPlural: 'volwassenen',
    childSingular: 'kind',
    childPlural: 'kinderen',
    infantSingular: 'baby',
    infantPlural: "baby's",
    passengerDetail: '{adults}{children}{infants}',
    urgentDeparture:
      'Voor vertrek binnen 24 uur zijn we rechtstreeks voor u beschikbaar. ',
    urgentDepartureLink: 'Neem rechtstreeks contact op. Elk uur van de dag, zonder uitzondering.',
    privateAviation: 'Privéluchtvaart',
    partnerHotelsTitle: 'Partnerhotels',
    headerNoteHotels: 'Alleen partnerhotels. Geen externe boekingssites.',
    country: 'Land',
    city: 'Stad',
    searchCountry: 'Land zoeken…',
    searchCity: 'Stad zoeken…',
    selectCountryFirst: 'Kies eerst een land',
    noCitiesForCountry: 'Geen steden in bestand voor {country} — vermeld dit bij Bijzondere wensen.',
    checkIn: 'Inchecken',
    checkOut: 'Uitchecken',
    numberOfGuests: 'Aantal gasten',
    guests: 'Gasten',
    guestsSingular: 'gast',
    guestsPlural: 'gasten',
    nightsSingular: '{n} nacht',
    nightsPlural: '{n} nachten',
    roomPreferences: 'Kamerwensen',
    roomSuite: 'Suite',
    roomConnecting: 'Communicerende kamers',
    roomHighFloor: 'Hoge verdieping',
    roomPrivacy: 'Volledige privacy',
    hotelSpecialPlaceholder: 'Toegankelijkheid, aankomsttijd, specifieke verzoeken…',
    duration: 'Duur',
    vehicleSedan: 'Executive sedan',
    vehicleSedanDesc: 'Mercedes S-Klasse of gelijkwaardig',
    vehicleSuv: 'Luxury SUV',
    vehicleSuvDesc: 'Mercedes GLS of gelijkwaardig',
    vehicleVan: 'Executive van',
    vehicleVanDesc: 'Mercedes V-Klasse of gelijkwaardig',
    vehicleMaybach: 'Maybach / ultraluxe',
    vehicleMaybachDesc: 'Onder voorbehoud van beschikbaarheid',
    vehicleSedanShort: 'Executive sedan',
    vehicleSuvShort: 'Luxury SUV',
    vehicleVanShort: 'Executive van',
    vehicleMaybachShort: 'Maybach / ultraluxe',
    journey: 'Rit',
    pickupLocation: 'Ophaallocatie',
    pickupPlaceholder: 'Hotel, adres of herkenningspunt',
    dropoffPlaceholder: 'Hotel, luchthaven of adres',
    dateAndTime: 'Datum en tijd',
    date: 'Datum',
    pickupTime: 'Ophaaltijd',
    vehiclePreference: 'Voertuigvoorkeur',
    transferSpecialPlaceholder: 'Kindzitjes, extra bagage, specifieke wensen…',
    passengerSingular: 'passagier',
    passengerPlural: 'passagiers',
    carTransfersSuccessNote:
      'Zodra uw boeking bevestigd is en de betaling ontvangen, ontvangt u een SMS met alle transferdetails.',
    airportTitle: 'Luchthavendiensten',
    flightDetails: 'Vluchtgegevens',
    airportField: 'Luchthaven',
    airportNamePlaceholder: 'Luchthavennaam of IATA-code',
    flightNumber: 'Vluchtnummer',
    flightNumberPlaceholder: 'bijv. SN123',
    serviceRequired: 'Gewenste dienst',
    svcArrivalTitle: 'Aankomst meet & greet',
    svcArrivalDesc: 'Onze vertegenwoordiger verwelkomt u bij het vliegtuig of de gate',
    svcDepartureTitle: 'Vertrekbegeleiding',
    svcDepartureDesc: 'Volledige begeleiding tot aan uw gate',
    svcTransferTitle: 'Privétransfer',
    svcTransferDesc: 'Privévoertuig van of naar de luchthaven',
    numberOfPassengers: 'Aantal passagiers',
    airportSpecialPlaceholder: 'Toegankelijkheid, VIP-wensen, specifieke verzoeken…',
    confirmAirport: 'Luchthaven',
    confirmFlightNumber: 'Vluchtnummer',
    confirmServices: 'Diensten',
    confirmVehicle: 'Voertuig',
    member: 'Lid',
    journal: 'Tijdschrift',
    backToJournal: 'Terug naar tijdschrift',
    readMinutes: 'Lees {time} →',
    readMinutesShort: '{time} →',
    articleReadMeta: '{date} · {readTime} lezen',
    aboutOverline: 'Mwuïlu',
    aboutTitle: 'Over ons',
    aboutLead: 'Hoofdfacilitator van particuliere en diplomatieke aangelegenheden.',
    aboutWhoLabel: 'Wie wij zijn',
    aboutWhatLabel: 'Wat wij doen',
    aboutHowLabel: 'Hoe wij werken',
    aboutMembershipLabel: 'Lidmaatschap',
    officeHours: 'Kantooruren',
    officeHoursDays: 'Maandag — vrijdag',
    officeHoursTime: '9:00 — 18:00 CET',
    urgentMatters: 'Urgente zaken',
    urgentOutsideHours: 'Bereikbaar buiten kantooruren',
    connect: 'Contact',
    linkedIn: 'LinkedIn',
    ariaLinkedIn: 'Mwuïlu op LinkedIn',
    historyTitle: 'Verzoekgeschiedenis',
    filterByService: 'Filter op dienst',
    filterAll: 'Alles',
    filterAviation: 'Luchtvaart',
    filterHotels: 'Hotels',
    filterTransfers: 'Transfers',
    filterAirport: 'Luchthaven',
    activeSection: 'Actief',
    previousSection: 'Eerder',
    allRequests: 'Alle verzoeken',
    requestDetail: 'Verzoekdetail',
    reference: 'Referentie',
    submitted: 'Ingediend',
    status: 'Status',
    details: 'Details',
    historyNotice:
      'Er worden geen prijzen getoond. Ons team neemt contact met u op over uw arrangement.',
    backToHistory: 'Terug naar geschiedenis',
    noRequestsYetAll: 'Nog geen ingediende verzoeken.',
    noRequestsForService: 'Geen {service}-verzoeken gevonden.',
    notesPickup: 'Ophalen {time}',
    notesFlexible: 'Flexibele data ±2 dagen',
    profileMemberOverline: 'Lid',
    profileTitle: 'Mijn profiel',
    changePhoto: 'Foto wijzigen',
    ariaChangePhoto: 'Profielfoto wijzigen',
    memberIdLabel: 'Lidnummer',
    memberIdNote: 'Beheerd door Mwuïlu. Niet bewerkbaar.',
    memberSince: 'Lid sinds {date}',
    personalDetails: 'Persoonlijke gegevens',
    fullName: 'Volledige naam',
    placeholderPassportName: 'Exact zoals in uw paspoort',
    hintPassportName: 'Uw naam moet exact overeenkomen met uw paspoort.',
    nameChangeAlert: 'Een naamswijziging wordt geregistreerd en met het team van Mwuïlu gedeeld.',
    emailAddress: 'E-mailadres',
    phoneNumber: 'Telefoonnummer',
    phonePlaceholder: '+32 2 xxx xx xx',
    countryOfResidence: 'Land van verblijf',
    selectCountry: 'Land kiezen…',
    professionalDetails: 'Professionele gegevens',
    institutionType: 'Cliëntclassificatie',
    institutionOther: 'Type instelling (toelichten)',
    institutionName: 'Naam instelling',
    institutionNamePlaceholder: 'Ambassade van de VAE, Acme Group…',
    jobTitle: 'Functie',
    jobTitlePlaceholder: 'Ambassadeur, CEO…',
    position: 'Rol',
    positionPlaceholder: 'Hoofd van de missie…',
    countryRepresented: 'Vertegenwoordigd land / opereert onder',
    savedCompanions: 'Opgeslagen reisgezelschap',
    addCompanion: '+ Metgezel toevoegen',
    companionsHelp:
      'Hier opgeslagen metgezellen kunt u meteen kiezen bij passagiers in verzoeken.',
    noCompanionsYet: 'Nog geen opgeslagen metgezellen.',
    editCompanion: 'Metgezel bewerken',
    removeCompanion: 'Metgezel verwijderen',
    relationship: 'Relatie',
    passportNumber: 'Paspoortnummer',
    passportNumberPlaceholder: 'Paspoortnummer',
    selectEllipsis: 'Kiezen…',
    roleSpouse: 'Echtgenoot/echtgenote',
    rolePartner: 'Partner',
    roleFriend: 'Vriend/vriendin',
    roleFamilyMember: 'Familielid',
    roleParent: 'Ouder',
    roleChild: 'Kind',
    roleSibling: 'Broer/zus',
    roleAssistant: 'Assistent',
    roleColleague: 'Collega',
    roleClient: 'Cliënt',
    roleCaregiver: 'Verzorger',
    roleOther: 'Overig',
    roleUnspecified: 'Niet opgegeven',
    companionDefaultName: 'Metgezel {n}',
    failedLoadProfile: 'Profiel laden mislukt.',
    avatarUploadFailed: 'Foto uploaden mislukt.',
    profileUpdated: 'Profiel bijgewerkt.',
    failedSave: 'Opslaan mislukt. Probeer het opnieuw.',
    saving: 'Opslaan…',
    saveChanges: 'Wijzigingen opslaan',
    instEmbassy: 'Particuliere cliënt',
    instConsulateGeneral: 'Family office',
    instConsulate: 'Privékantoor',
    instPermanentMission: 'Bedrijfsentiteit',
    instInternationalOrg: 'Overheid / Ministerie',
    instPrivateOffice: 'Ambassade / Consulaat',
    instCorporate: 'Permanente missie',
    instGovernmentMinistry: 'Internationale organisatie',
    instRoyalHousehold: 'Koninklijk Huis',
    instrepresent: 'Vertegenwoordiger (namens een opdrachtgever)',
    instOther: 'Overig',
    asOnPassport: 'Zoals in paspoort',
    aboutWhoBody: `Mwuïlu is een privé facilitationbureau op het snijvlak van diplomatie, discretie en excellentie. Wij bedienen een zorgvuldig samengestelde kring van ambassades, consulaten‑generaal, permanente vertegenwoordigingen, internationale organisaties en particuliere cliënten van het hoogste niveau.

Wij adverteren niet. Wij bundelen niet. Wij delen niet. Elk arrangement wordt persoonlijk behandeld, met volledige aandacht en absolute vertrouwelijkheid.`,
    aboutWhatBody: `Mwuïlu is een privé facilitationbedrijf gevestigd in België. Wij bedienen een zorgvuldig samengestelde kring van ambassades, consulaten‑generaal, permanente vertegenwoordigingen, internationale organisaties en particuliere cliënten wier dossiers de hoogste zorg vereisen.

Elk arrangement wordt persoonlijk behandeld. Elk detail krijgt volledige aandacht. Elk vertrouwen wordt zonder uitzondering bewaard.

Dit is geen "dienst" die wij verkopen. Zo werken wij nu eenmaal.`,
    aboutHowBody: `Wij regelen wat het belangrijkst is wanneer tijd en discretie niet onderhandelbaar zijn. Vluchten, partnerhotels, grondtransfers en luchthavencoördinatie worden van eerste contact tot finale bevestiging door ons team afgehandeld — niet door een algoritme.

Onze partners zijn gekozen op kwaliteit, betrouwbaarheid en begrip voor het serviceniveau dat onze leden verwachten. Geen externe aggregators. Geen geautomatiseerde boeking. Elk detail, persoonlijk beheerd.

Een verzoek via dit portaal bereikt ons team binnen enkele minuten. Wij zoeken de best beschikbare opties in alle cabineklassen en presenteren binnen het uur een voorstel op maat.

Betaling verloopt via een beveiligde link die rechtstreeks aan u wordt gestuurd. Geen kaartgegevens op onze servers. Paspoorten en persoonsdocumenten zijn versleuteld, alleen voor ons team toegankelijk en worden na voltooiing van uw boeking verwijderd.

Ons team is bereikbaar maandag tot vrijdag, 9.00 tot 18.00 CET. Voor urgente dossiers, inclusief dezelfde dag en de volgende dag, blijven wij ook daarbuiten bereikbaar.`,
    aboutMembershipBody: `Lidmaatschap bij Mwuïlu is alleen op uitnodiging. Elk nieuw lid wordt persoonlijk gescreend en via een directe introductie onboarded. Er is geen open registratie.

Als u dit portaal gebruikt, bent u al een gewaardeerd lid van onze kring. Wij zijn vereerd met het vertrouwen dat u in ons stelt.`,
    blog1Category: 'Inzicht',
    blog1Title: 'De kunst van de stille aankomst',
    blog1Excerpt:
      'Wat een naadloze luchthavenervaring onderscheidt van een louter efficiënte is niet snelheid — het is de kwaliteit van anticipatie. Een noot over hoe wij elk vertrek en elke aankomst voor onze leden benaderen.',
    blog1Date: '18 april 2026',
    blog1ReadTime: '4 min',
    blog1Body: `Er is een bepaalde spanning die bij vliegreizen hoort — niet de angst om te vliegen, maar het stapeling van kleine onzekerheden. Komt de auto op tijd? Is de lounge bereikbaar? Staat er iemand aan de gate?

Voor de leden die wij bedienen zijn dit niet alleen ongemakken. Het is de kloof tussen wat wordt verwacht en wat wordt geleverd.

Onze aanpak van luchthavencoördinatie begint ruim vóór de landing. Wij bevestigen de avond ervoor de grondafhandeling met de handler. Wij volgen de vlucht realtime. Onze vertegenwoordiger staat klaar niet "als het vliegtuig landt", maar wanneer het nadert.

De stille aankomst is geen afwezigheid van service — het is haar hoogste vorm. Geen wrijving, geen onzekerheid, wel iemand die al weet wat nodig is.

Dat bedoelen wij met faciliteren. Niet alleen regelen, maar anticiperen. Zodat de ruimte tussen hier en daar voor onze leden net zo vloeiend is als alles wat volgt.`,
    blog2Category: 'Reizen',
    blog2Title: 'Brussel in de lente: een privé blik',
    blog2Excerpt:
      'Voor wie Brussel thuis noemt — of dat een seizoen lang doet — ontvouwt de stad zich langzaam. Het institutionele gewicht van de EU‑wijk maakt in april plaats voor iets intiemers.',
    blog2Date: '11 april 2026',
    blog2ReadTime: '6 min',
    blog2Body: `Brussel laat zich moeilijk vangen. Het is niet Parijs, al gebaart de architectuur soms die kant op. Het is niet Amsterdam, al suggereren grachten een Noordelijke verwantschap. Het is, het meest juist, zichzelf — stilletjes kosmopolitisch, ingetogen zelfverzekerd, en haast terughoudend om zich te profileren.

In de lente opent de stad. Het Jubelpark wordt weer comfortabel zonder overjas. De terrassen in Chatelain vullen zich op een uur dat elders vroeg zou heten. De antiekmarkt op de Zavel vindt zijn weekendritme terug.

Voor leden gestationeerd in Brussel — bij een van de vele ambassades of missies — valt die seizoensverschuiving extra op. Het diplomatieke ritme versnelt met het mildere weer, en de vraag naar naadloze grondlogistiek stijgt mee.

Wat ons betreft beloont Brussel wie voorbij het voor de hand liggende kijkt. Stanhope en Amigo blijven geliefd om goede redenen. Maar kleinere huizen — Pillows, Made in Louise — bieden soms meer discretie en rust dan de grote adressen niet altijd kunnen garanderen.

Komt u deze lente naar Brussel, of ontvangt u gasten die u goed wilt laten aankomen, spreek ons aan. Wij kennen de stad — en wat zij vraagt van wie er doorheen beweegt.`,
    blog3Category: 'Luchtvaart',
    blog3Title: 'Cabineklassen: waarom er maar twee zijn',
    blog3Excerpt:
      'Mwuïlu regelt uitsluitend business- en firstclassreizen. Dit is geen beperking — het is een bewuste keuze. Een korte uitleg.',
    blog3Date: '3 april 2026',
    blog3ReadTime: '3 min',
    blog3Body: `Soms wordt gevraagd of wij ook economy kunnen boeken. Het antwoord is nee, en de reden is eenvoudig.

De leden die wij bedienen reizen om redenen die geen compromis dulden. Een zitting in Den Haag. Een bilateraal op een niet-openbare locatie. Een familiekwestie die onmiddellijke aanwezigheid en absolute discretie vereist. Reiskwaliteit is hier geen luxe‑overweging — ze is functioneel.

Businessclass biedt op de routes en carriers waarmee wij werken de afzondering, rust en flexibiliteit die nodig is. First class gaat verder, met privacy‑suites op intercontinentale trajecten die voor sommige leden de enige aanvaardbare optie zijn.

Wij bieden geen economy omdat wij die niet op ons niveau kunnen leveren. En wij doen niets half.

Dienen u via dit portaal een vluchtverzoek in, dan vindt u twee opties: Business en First. Heeft u een voorkeur voor een maatschappij, configuratie of toestel, laat het weten. Wij doen wat mogelijk is. Daarvoor zijn wij er.`,
  },
}